@if (headerData(); as data) {
  <lib-organism-header-intro
    [leftNavItems]="data.topLeftnavigation"
    [staticTextItem]="data.static_text"
    [locales]="locales()"
    [activeLocale]="activeLocale()"
    [hideLogin]="hideLoginHeader()"
    (localeChange)="onLanguageChange($event)"
    (loginClick)="onLoginClick()"
    (accountClick)="onAccountClick()"
  />
  <lib-header-main
    [shopMenu]="data.shop_menu"
    [personalMenu]="data.personal_menu"
    [personalMenuMobile]="data.personal_menu_mobile"
    [siteBranding]="data.site_branding"
    [telkomselBranding]="data.telkomsel_site_branding"
    [popularKeywords]="data.popular_keywords"
    [productRecommendations]="data.product_recommendation"
    [categoryRecommendations]="data.category_recommendation"
    [staticTextItem]="data.static_text"
    [locales]="locales()"
    [activeLocale]="activeLocale()"
    (localeChange)="onLanguageChange($event)"
  />
} @else {
  <div class="header">
    <div class="header-intro__spacer">
    </div>
    <div class="header-intro">
      <div class="header-intro__inner">
         @for (bar of barsIntro(); track $index) {
          <div
              class="skeleton-bar"
              [style.--bar-height]="bar.height ?? '20px'"
              [style.--bar-height-mobile]="bar.heightMobile ?? bar.height ?? '16px'"
              [style.--bar-width]="bar.width ?? '100%'"
              [style.--bar-width-mobile]="bar.widthMobile ?? bar.width ?? '100%'"
          ></div>
        }
      </div>
    </div>
    <div class="header-main">
      <div class="header-main__inner">
        @for (bar of barsMain(); track $index) {
          <div
              class="skeleton-bar"
              [style.--bar-height]="bar.height ?? '20px'"
              [style.--bar-height-mobile]="bar.heightMobile ?? bar.height ?? '16px'"
              [style.--bar-width]="bar.width ?? '100%'"
              [style.--bar-width-mobile]="bar.widthMobile ?? bar.width ?? '100%'"
          ></div>
        }
      </div>
    </div>
  </div>
}

<div class="app-wrapper">
  <router-outlet></router-outlet>

  @if (dataFooter()) {
    <lib-organism-footer [data]="dataFooter()!"  />
  }
</div>

<app-login-iframe #loginIframe />
